/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_FailedInputs */



/**
* | output |
* | --- |
* | "That did not work. Try again." |
*
* @param {Manual_Meeting_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_failed = /** @type {((inputs?: Manual_Meeting_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat lukte niet. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela n'a pas fonctionné. Réessayez.")
	return /** @type {LocalizedString} */ ("That did not work. Try again.")
});